import React from "react";
import { StyleSheet, View } from "react-native";
import { Text } from "@/components/base";
import { brand, colors, layout } from "@/constants";
import { useCrisisResources } from "@/hooks/crisis";

/**
 * Footer shown across screens reminding the user that the AI can make
 * mistakes, with a link to crisis resources.
 */
export default function DisclaimerFooter() {
  const { openResources } = useCrisisResources();

  return (
    <View style={styles.container}>
      <Text size="xsmall" color="tertiary" style={styles.text}>
        {brand.name} is AI and can make mistakes.{" "}
        <Text
          size="xsmall"
          color="tertiary"
          style={styles.link}
          onPress={openResources}
          accessibilityRole="link"
          accessibilityLabel="Open crisis resources"
        >
          Crisis resources
        </Text>
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: layout.space.sm,
    paddingHorizontal: layout.space.lg,
    borderTopColor: colors.outline,
    alignItems: "center"
  },
  text: {
    textAlign: "center"
  },
  link: {
    textDecorationLine: "underline"
  }
});
